// extracted by mini-css-extract-plugin
export var closeButton = "_ok-2";
export var closeButtonIcon = "_ok-3";
export var lightboxContent = "_ok-1";
export var lightboxOverlay = "_ok-0";